import { useState } from "react";
import SectionHead, { renderLines, sectionText, toParagraphs } from "./SectionHead";

// Questions on a Custom page: the pro's question and answer pairs, up to 20.
// The first starts open; a tap opens or closes any of them, and several can
// be open at once. A question with no answer isn't shown, and with no
// questions there's no section.

export const MAX_PUBLIC_FAQ_ITEMS = 20;

export const readFaqItems = (items) =>
  (Array.isArray(items) ? items : [])
    .map((item) => ({
      question: sectionText(item?.question),
      answer: sectionText(item?.answer),
    }))
    .filter((item) => item.question && item.answer)
    .slice(0, MAX_PUBLIC_FAQ_ITEMS);

const ChevronIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
);

const ProfileFaqSection = ({ sectionId = "faq", content }) => {
  const items = readFaqItems(content?.items);
  const [openItems, setOpenItems] = useState(() => new Set([0]));

  if (items.length === 0) return null;

  const heading = sectionText(content?.heading) || "Questions";
  const idPrefix = `profile-section-${sectionId}`;
  const toggle = (index) =>
    setOpenItems((current) => {
      const next = new Set(current);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });

  return (
    <section className="profile-block profile-faq" aria-labelledby={`${idPrefix}-heading`}>
      <SectionHead id={`${idPrefix}-heading`} heading={heading} />
      <div className="profile-block__card profile-faq__list">
        {items.map((item, index) => {
          const open = openItems.has(index);
          const answerId = `${idPrefix}-answer-${index}`;
          return (
            <div key={index} className={`profile-faq__item${open ? " is-open" : ""}`}>
              <h3 className="profile-faq__question">
                <button
                  type="button"
                  className="profile-faq__toggle"
                  aria-expanded={open}
                  aria-controls={answerId}
                  onClick={() => toggle(index)}
                >
                  <span className="profile-faq__question-text">{item.question}</span>
                  <span className="profile-faq__chevron">
                    <ChevronIcon />
                  </span>
                </button>
              </h3>
              <div className="profile-faq__answer" id={answerId} hidden={!open}>
                {toParagraphs(item.answer).map((paragraph, paragraphIndex) => (
                  <p key={paragraphIndex}>{renderLines(paragraph)}</p>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ProfileFaqSection;
